export default __webpack_public_path__ + "static/media/support_1.696eda86.jpg";